import React, { Fragment } from 'react';
import InputRange from '../common/Forms/InputRange';
import {
  TimePlannerActions,
  TimePlannerActionType,
  TimePlanner_Interval,
  TimePlanner_Day,
  TimePlanner_Hour,
  TimePlannerState,
} from './types';
import { formatJustHour } from '../../utils/dateUtil';
import { TimePlannerInner } from './TimePlanner.styled';

interface ITimePlannerSlidersProps {
  dispatch: React.Dispatch<TimePlannerActions>;
  reducerState: TimePlannerState;
  cubicleCount: number;
  staffOnly: boolean;
}

const getOnlinePlanned = (
  slot: TimePlanner_Day | TimePlanner_Hour | TimePlanner_Interval,
) => slot.total_planned - slot.staff_only_planned;

const getSliderValue = (
  slot: TimePlanner_Day | TimePlanner_Hour | TimePlanner_Interval,
  staffOnly: boolean,
) => (staffOnly ? slot.total_planned : getOnlinePlanned(slot));

export const TimePlannerSliders: React.FunctionComponent<
  ITimePlannerSlidersProps
> = ({ dispatch, reducerState: { day }, cubicleCount, staffOnly }) => {
  return (
    <TimePlannerInner>
      <InputRange
        showMaxTopRight
        max={cubicleCount}
        value={getSliderValue(day, staffOnly)}
        prefix="Day"
        prefixType="big"
        color="var(--yellowaction)"
        textColor="var(--textprimary)"
        onChange={(value) =>
          dispatch({
            type: TimePlannerActionType.SET_DAY_LIMIT,
            payload: {
              value,
              staffOnly,
            },
          })
        }
      />

      {day.hours.map((hour, hourIndex) => (
        <Fragment key={hour.hourNumber}>
          <InputRange
            max={cubicleCount}
            value={getSliderValue(hour, staffOnly)}
            prefix={formatJustHour(hour.hourNumber)}
            prefixType="big"
            color="var(--greenprimary)"
            onChange={(value) =>
              dispatch({
                type: TimePlannerActionType.SET_HOUR_LIMIT,
                payload: {
                  value,
                  hourIndex,
                  staffOnly,
                },
              })
            }
          />
          {hour.intervals.map((interval, intervalIndex) => (
            <InputRange
              key={'Intervals_' + hour.hourNumber + '_' + intervalIndex * 60}
              prefix={`:${interval.minute}`}
              max={cubicleCount}
              value={getSliderValue(interval, staffOnly)}
              color="var(--greenprimary)"
              onChange={(value) =>
                dispatch({
                  type: TimePlannerActionType.SET_INTERVAL_LIMIT,
                  payload: {
                    value,
                    hourIndex,
                    intervalIndex,
                    staffOnly,
                  },
                })
              }
            />
          ))}
        </Fragment>
      ))}
    </TimePlannerInner>
  );
};
